export class MemberContractViewModel {
    public displayName?: string;
    public constructor(displayName: string) {
        this.displayName = displayName;
    }
}
